<template>
    <div>
      <!-- ============================================================== -->
      <!-- Container fluid  -->
      <!-- ============================================================== -->
      <div class="container-fluid">
        <!-- ============================================================== -->
        <!-- Bread crumb and right sidebar toggle -->
        <!-- ============================================================== -->
        <div class="row page-titles">
          <div class="col-md-5 col-8 align-self-center">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link to="/home">Home</router-link>
              </li>
              <li class="breadcrumb-item active">スタッフ(テレッサ・スタンダード)</li>
            </ol>
          </div>
        </div>
        <!-- ============================================================== -->
        <!-- End Bread crumb and right sidebar toggle -->
        <!-- ============================================================== -->
        <div class="row">
          <div class="col-12">
            <!-- Column -->
            <div class="card">
              <div class="card-body">
                <div class="">
                  <div class="row">
                    <div class="col-4">
                      <div class="form-group" :class="{'has-danger': errors.office_id }">
                        <label class="control-label">事業所</label>
                        <select-office
                          v-model="inputs.office_id"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-8">
                      <div class="form-group" :class="{'has-danger': errors.file }">
                        <label class="control-label">ファイル</label>
                        <input
                          type="file"
                          class="form-control"
                          accept=".csv"
                          @change="onFileChange"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-actions">
                  <div class="row">
                    <div class="col-md-12 text-center">
                      <button
                        type="button"
                        class="action-button btn btn-success btn-rounded"
                        @click="save"
                        :disabled="isProcessing"
                      >
                        インポート
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Column -->
          </div>
        </div>
        <div class="row" v-if="Object.keys(errors).length > 0">
          <div class="col-md-12">
            <div class="alert alert-warning">
              <button type="button" class="close" @click="errorsClear" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <ul>
                <li v-for="(error, field) in errors" :key="field">
                  {{ error }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>

<script setup>
import { ref } from 'vue'
import { useToast } from 'vue-toastification'
import api from '../../libs/Api'
import SelectOffice from '../../components/SelectOffice'
import * as yup from 'yup'

// Setup toast
const toast = useToast()

// State
const inputs = ref({
  file: null,
  office_id: null
})
const isProcessing = ref(false)
const errors = ref({})

// Validation schema
const validationSchema = yup.object({
  office_id: yup.string().required('事業所は必須です'),
  file: yup.mixed().required('ファイルは必須です')
})

// const validateField = async (fieldName) => {
//   try {
//     await validationSchema.validateAt(fieldName, inputs.value)
//     delete errors.value[fieldName]
//   } catch (error) {
//     errors.value[fieldName] = error.message
//   }
// }

const validateForm = async () => {
  try {
    await validationSchema.validate(inputs.value, { abortEarly: false })
    errors.value = {}
    return true
  } catch (error) {
    const newErrors = {}
    error.inner.forEach(err => {
      newErrors[err.path] = err.message
    })
    errors.value = newErrors
    return false
  }
}

const onFileChange = (e) => {
  const files = e.target.files || e.dataTransfer.files
  inputs.value.file = files[0]
  // validateField('file')
}

const errorsClear = () => {
  errors.value = {}
}

const save = async () => {
  try {
    const isValid = await validateForm()
    if (!isValid) return

    isProcessing.value = true
    const result = await api.importTeresaStandardStaff(inputs.value)

    if (result) {
      if (result.length > 0) {
        result.forEach((error, index) => {
          errors.value[`line_${index + 1}`] = error
        })
        errors.value.file = '上記の行数が取り込めませんでした。'
      } else {
        toast.success('インポートに成功しました。')
      }
    }
  } catch (error) {
    console.error('Error importing staff:', error)
    toast.error('インポートに失敗しました。')
  } finally {
    isProcessing.value = false
  }
}
</script>

<style lang="scss" scoped>
</style>
